export const selectedItemStyle = "ring-2 ring-purple-500 bg-purple-100";

export const stickyNoteStyles = {
  note: {
    position: 'absolute',
    padding: '12px',
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'move',
    minHeight: '40px',
    height: 'auto',
    width: '250px',
    maxWidth: '250px',
    transition: 'box-shadow 0.2s ease, opacity 0.2s ease',
  },
  dragHandle: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '10px',
    cursor: 'move',
    backgroundColor: 'transparent',
    transition: 'background-color 0.2s ease',
  },
};